import { Height } from '@mui/icons-material';
import { Box, Menu, Typography, alpha, styled } from '@mui/material';

export const Container = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%; 
    height: 70px;
    background: ${props => props.theme.palette.background.paper};
    display: flex;
    justify-content: space-between;
    z-index: 999;
`;

export const StyleValueCart = styled(Typography)`
    color: white;
    background: #f1416d;
    border-radius: 25px;
    width: 16px;
    height: 15px;
    font-size: 10px !important;
    text-align: center;
    margin-top: -3px;

    @media screen and (max-width: 600px) {
        margin-top: -30px;
    }

    margin-left: -8px !important;
`;

export const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        padding: 10,
        maxHeight: 250,
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));